import {ChapterStatus} from "it/primatoo/openapi/api/org/schemas/common/docs/ChapterStatus";
import {UserInfo} from "it/primatoo/openapi/api/org/schemas/common/UserInfo";
import {GetChapterResponse} from "it/primatoo/openapi/api/org/schemas/common/docs/GetChapterResponse";

export class ChapterInfo {
  status?: ChapterStatus;
  completed?: number;
  lastUpdatedAt?: number;
  lastUpdateUser?: UserInfo;

  static fromGetChapterResponse(chapter?: GetChapterResponse): ChapterInfo | undefined {
    if (chapter) {
      const response = {
        status: chapter.status,
        completed: chapter.completed,
        lastUpdatedAt: chapter.lastUpdatedAt,
        lastUpdateUser: chapter.lastUpdateUser
      }
      return response;
    }
    return undefined;
  }
}
